export default "__VITE_ASSET__BuyC9ieE__"